export default "__VITE_ASSET__202daf3d__"